import React from 'react'
import {
  Container,
  Row,
  Col, Card, CardTitle, CardBody,
} from 'reactstrap'
import books from '../../data/book-data'
import Book from '../Book/Book'
import './NewReleases.scss'

function NewReleases() {

  let newBook = books[books.length - 1]

  const createMarkup = () => ({ __html: newBook.copy })

  return (
    <Container fluid className="NewReleases d-flex flex-column align-items-center py-5">
      <Card className="bg-light border-0 w-100" style={{ maxWidth: '900px' }}>
        <CardBody className="p-4">
          <CardTitle className="text-center mb-4">
            <h1 className="h1">New From Jane</h1>
          </CardTitle>

          <Row className="align-items-center">
            <Col xs="12" md="7" className="my-4 mb-md-0">
              <h2 className="h2 text-center text-dark">{newBook.title}</h2>
              <p className="h4 text-center text-muted">{newBook.subtitle}</p>
              <div id="SeeMoreTooltip" className="d-flex justify-content-center">
                <Book {...newBook} />
              </div>
            </Col>

            <Col xs="12" md="5" className="border-left-md pt-3 pt-md-0">
              <div
                className="text-justify"
                dangerouslySetInnerHTML={createMarkup()}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  )

}

export default NewReleases
